const ASSETS_DIR = 'node_modules/@collaborator/npm_modules/src/media';
const ASSETS_KEY = '@core-images';
const IMAGES_URL = '/images';
const IMAGES_ALIAS = '/images';
module.exports = {
    ASSETS: [ASSETS_KEY, ASSETS_DIR],
    IMAGES: [IMAGES_ALIAS, IMAGES_URL],
};
